<div class="rd-widget hrentrollHeightPerLine widget-{{widgetConfig.widgetId}} table-widget rd-widget-no-height-restriction" *ngIf="widgetData">

  <table data-id="widgetHRentRoll" class="widget-hpage-large widget-HRentRoll CommentDesign widget-HRentRollScenario widget-HRentRollScenario-fixed-top" aria-hidden="true">
    <!-- Header -->
    <thead>
      <ng-container *ngTemplateOutlet="widgetRuller"></ng-container>

      <tr class="color-grey-widget-line">
        <th scope="col" colspan="6" class="widget-align-left valign-top">{{'hRentRoll.tenantName' | rdTranslate}}</th>
        <th scope="col" colspan="5" class="widget-align-left valign-top">{{'hRentRoll.areaCategory' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.lettableArea' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.units' | rdTranslate}}</th>
        <th scope="col" colspan="6" class="widget-align-center-adjusted valign-top">{{'hRentRoll.labelLease' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.walt' | rdTranslate}}</th>
        <th scope="col" colspan="6" class="widget-align-center-adjusted valign-top">{{'hRentRoll.contractualRent' | rdTranslate}}</th>
        <th scope="col" colspan="6" class="widget-align-center-adjusted valign-top">{{'hRentRoll.marketRent' | rdTranslate}}</th>
        <th scope="col" colspan="7" class="widget-align-center valign-top" style="padding-right: 15px;">{{'hRentRoll.tenantIndexation' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.initialLeaseUpPeriod' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.reLettingPeriod' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.rentFreePeriod' | rdTranslate}}</th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">{{'hRentRoll.leasingCommissions' | rdTranslate}}</th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">{{'hRentRoll.tenantImprovements' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.leaseTerm' | rdTranslate}}</th>
      </tr>

      <tr class="color-grey-widget-line">
        <th scope="col" colspan="6" class="widget-align-left valign-top">&nbsp;</th>
        <th scope="col" colspan="5" class="widget-align-left valign-top">&nbsp;</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{unitOfLength}}²</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.labelAmount' | rdTranslate}}</th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">{{'hRentRoll.leaseStart' | rdTranslate}}</th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">{{'hRentRoll.leaseEnd' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.labelYears' | rdTranslate}}</th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}}/year</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}}/month</span>
        </th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}}/{{unitOfArea}}/year</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}}/{{unitOfArea}}/month</span>
        </th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}}/year</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}}/month</span>
        </th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}}/{{unitOfArea}}/year</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}}/{{unitOfArea}}/month</span>
        </th>
        <th scope="col" colspan="3" class="widget-align-center valign-top">{{'hRentRoll.labelRenewal' | rdTranslate}}</th>
        <th scope="col" colspan="4" class="widget-align-center valign-top">{{'hRentRoll.labelContract' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.labelMonths' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.labelMonths' | rdTranslate}}</th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.labelMonths' | rdTranslate}}</th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">
          <span *ngIf="!widgetData.tenantLeasingCommissionsMonthsLabelOverride">{{'hRentRoll.labelMonths' | rdTranslate}}</span>
          <span *ngIf="widgetData.tenantLeasingCommissionsMonthsLabelOverride">{{widgetData.tenantLeasingCommissionsMonthsLabelOverride}}</span>
        </th>
        <th scope="col" colspan="3" class="widget-align-right valign-top">
          <span *ngIf="!widgetData.tenantTenantImprovementsPerSqmLabelOverride">{{'hRentRoll.labelMonths' | rdTranslate}}</span>
          <span *ngIf="widgetData.tenantTenantImprovementsPerSqmLabelOverride">{{widgetData.tenantTenantImprovementsPerSqmLabelOverride}}</span>
        </th>
        <th scope="col" colspan="2" class="widget-align-right valign-top">{{'hRentRoll.labelYears' | rdTranslate}}</th>
      </tr>
    </thead>
  </table>

  <table data-id="widgetHRentRoll" class="widget-hpage-large widget-HRentRoll CommentDesign widget-HRentRollScenario widget-HRentRollScenario-content" aria-hidden="true">
    <thead>
      <ng-container *ngTemplateOutlet="widgetRuller"></ng-container>
    </thead>
    <!-- Let rows -->
    <tbody>
      <tr *ngFor="let entry of widgetData.rowsLet; trackBy: trackById" class="hrentrollLine hrentrollLineLet">
        <td colspan="6" class="tenant-name-td" [ngClass]="{'reabsorb': debugReabsorb && entry.tenantReabsorb, 'absorbed': debugReabsorb && entry.tenantAbsorbed }">
          <div class="widget-text-value widget-align-left">{{ entry.tenantName }}</div>
        </td>
        <td colspan="5" class="widget-text-value widget-align-left">{{( entry.areaCategory)}} AFF{{entry.affectsOccupancy}}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{( (entry.lettableArea || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{( (entry.units || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.leaseStart | rdLocalizedDate }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.leaseEnd | rdLocalizedDate }}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{ entry.walt | rdLocalizedNumber:1:true }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{ (entry.contractualRent) | rdLocalizedNumber:0:true }}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{ (entry.contractualRent / 12) | rdLocalizedNumber:0:true }}</span>
        </td>
        <td colspan="3" class="widget-text-value widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{ (entry.contractualRentPerArea) | rdLocalizedNumber:2:true }}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{ (entry.contractualRentPerArea / 12) | rdLocalizedNumber:2:true }}</span>
        </td>
        <td colspan="3" class="widget-text-value widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{ entry.rentalValue | rdLocalizedNumber:0:true }}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{ entry.marketRent | rdLocalizedNumber:0:true }}</span>
        </td>
        <td colspan="3" class="widget-text-value widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{ entry.marketRentPerArea * 12 | rdLocalizedNumber:2:true }}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{ entry.marketRentPerArea | rdLocalizedNumber:2:true }}</span>
        </td>
        <td colspan="2" class="widget-text-value widget-align-right">{{ entry.tenantIndexationRenewal * 100 | rdLocalizedNumber:0 }}%</td>
        <td colspan="5" class="widget-text-value widget-align-right word-break">{{ entry.tenantIndexation }}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{ entry.initialLeaseUpPeriod | rdLocalizedNumber:0:true }}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{ entry.reLettingPeriod | rdLocalizedNumber:0:true }}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{ entry.rentFreePeriod | rdLocalizedNumber:1:true }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.leasingCommissions | rdLocalizedNumber:1:true}}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.tenantImprovements | rdLocalizedNumber:1:true }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.leaseTerm | rdLocalizedNumber:0:true}}</td>
      </tr>
    </tbody>

    <!-- Total Let -->
    <tbody *ngIf="widgetData.displayLetSubtotal">
      <tr class="displayLetSubtotal">
        <td colspan="6" class="widget-text-total widget-bold widget-align-left">{{'hRentRoll.labelTotalLet' | rdTranslate}}</td>
        <td colspan="5" class="widget-text-total"></td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right">{{( (widgetData.lettableAreaSumLet || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right">{{( (widgetData.unitsSumLet || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="6" class="widget-text-total">&nbsp;</td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right"></td>
        <td colspan="3" class="widget-text-total widget-bold widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{( ((widgetData.contractualRentSumLet) || 0) | rdLocalizedNumber:0:true )}}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{( ((widgetData.contractualRentSumLet / 12) || 0) | rdLocalizedNumber:0:true )}}</span>
        </td>
        <td colspan="3" class="widget-text-total">&nbsp;</td>
        <td colspan="3" class="widget-text-total widget-bold widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{( (widgetData.marketRentSumLet * 12 || 0) | rdLocalizedNumber:0:true )}}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{( (widgetData.marketRentSumLet || 0) | rdLocalizedNumber:0:true )}}</span>
        </td>
        <td colspan="3" class="widget-text-total">&nbsp;</td>

        <td colspan="21" class="widget-text-total">&nbsp;</td>
      </tr>
    </tbody>

    <!-- Empty row -->
    <tbody *ngIf="widgetData.displayLetSubtotalSpace">
      <tr class="emptyRow displayLetSubtotalSpace"><td colspan="56">&nbsp;</td></tr>
    </tbody>

    <!-- Vacant rows -->
    <tbody>
      <tr *ngFor="let entry of widgetData.rowsVacant; trackBy: trackById" class="hrentrollLine hrentrollLineVacant">
        <td colspan="6" class="tenant-name-td" [ngClass]="{'reabsorb': debugReabsorb && entry.tenantReabsorb, 'absorbed': debugReabsorb && entry.tenantAbsorbed }">
          <div class="widget-text-value widget-align-left">{{ entry.tenantName }}</div>
        </td>
        <td colspan="5" class="widget-text-value widget-align-left">{{( entry.areaCategory)}}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{( (entry.lettableArea || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{( (entry.units || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.leaseStart | rdLocalizedDate }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.leaseEnd | rdLocalizedDate }}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{ entry.walt | rdLocalizedNumber:1:true }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{ (entry.contractualRent) | rdLocalizedNumber:0:true }}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{ (entry.contractualRent / 12) | rdLocalizedNumber:0:true }}</span>
        </td>
        <td colspan="3" class="widget-text-value widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{ (entry.contractualRentPerArea) | rdLocalizedNumber:2:true }}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{ (entry.contractualRentPerArea / 12) | rdLocalizedNumber:2:true }}</span>
        </td>
        <td colspan="3" class="widget-text-value widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{ entry.rentalValue | rdLocalizedNumber:0:true }}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{ entry.marketRent | rdLocalizedNumber:0:true }}</span>
        </td>
        <td colspan="3" class="widget-text-value widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{ entry.marketRentPerArea * 12 | rdLocalizedNumber:2:true }}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{ entry.marketRentPerArea | rdLocalizedNumber:2:true }}</span>
        </td>
        <td colspan="2" class="widget-text-value widget-align-right">{{ entry.tenantIndexationRenewal * 100 | rdLocalizedNumber:0 }}%</td>
        <td colspan="2" class="widget-text-value widget-align-right word-break">{{ entry.tenantIndexation }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.initialLeaseUpPeriod | rdLocalizedNumber:0:true }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.reLettingPeriod | rdLocalizedNumber:0:true }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.rentFreePeriod | rdLocalizedNumber:1:true }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.leasingCommissions | rdLocalizedNumber:1:true }}</td>
        <td colspan="3" class="widget-text-value widget-align-right">{{ entry.tenantImprovements | rdLocalizedNumber:1:true }}</td>
        <td colspan="2" class="widget-text-value widget-align-right">{{ entry.leaseTerm | rdLocalizedNumber:0:true }}</td>

        <td colspan="22"></td>
      </tr>
    </tbody>

    <!-- Total Vacant -->
    <tbody *ngIf="widgetData.displayVacantSubtotal">
      <tr class="displayVacantSubtotal">
        <td colspan="6" class="widget-text-total widget-bold widget-align-left">{{'hRentRoll.labelTotalVacant' | rdTranslate}}</td>
        <td colspan="5" class="widget-text-total"></td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right">{{( (widgetData.lettableAreaSumVacant || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right">{{( (widgetData.unitsSumVacant || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="6" class="widget-text-total">&nbsp;</td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right"></td>
        <td colspan="3" class="widget-text-total widget-bold widget-align-right">
          <span>0</span>
        </td>
        <td colspan="3" class="widget-text-total">&nbsp;</td>
        <td colspan="3" class="widget-text-total widget-bold widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{( (widgetData.marketRentSumVacant * 12 || 0) | rdLocalizedNumber:0:true )}}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{( (widgetData.marketRentSumVacant || 0) | rdLocalizedNumber:0:true )}}</span>
        </td>
        <td colspan="3" class="widget-text-total">&nbsp;</td>

        <td colspan="21" class="widget-text-total">&nbsp;</td>
      </tr>
    </tbody>

    <!-- Empty row -->
    <tbody *ngIf="widgetData.displayVacantSubtotalSpace">
      <tr class="emptyRow displayVacantSubtotalSpace"><td colspan="56">&nbsp;</td></tr>
    </tbody>

    <!-- Total(Let + Vacant) -->
    <tbody *ngIf="widgetData.displayTotal">
      <tr class="displayTotal">
        <td colspan="6" class="widget-text-total widget-bold widget-align-left">{{'hRentRoll.labelTotalTotal' | rdTranslate}}</td>
        <td colspan="5" class="widget-text-total"></td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right">{{( (widgetData.lettableAreaSumTotal || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right">{{( (widgetData.unitsSumTotal || 0) | rdLocalizedNumber:0:true )}}</td>
        <td colspan="6" class="widget-text-total">&nbsp;</td>
        <td colspan="2" class="widget-text-total widget-bold widget-align-right"></td>
        <td colspan="3" class="widget-text-total widget-bold widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{( ((widgetData.contractualRentSumTotal) || 0) | rdLocalizedNumber:0:true )}}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{( ((widgetData.contractualRentSumTotal / 12) || 0) | rdLocalizedNumber:0:true )}}</span>
        </td>
        <td colspan="3" class="widget-text-total">&nbsp;</td>
        <td colspan="3" class="widget-text-total widget-bold widget-align-right">
          <span *ngIf="widgetData.displayValuesOverTimeId == 1">{{( (widgetData.marketRentSumTotal * 12 || 0) | rdLocalizedNumber:0:true )}}</span>
          <span *ngIf="widgetData.displayValuesOverTimeId == 2">{{( (widgetData.marketRentSumTotal || 0) | rdLocalizedNumber:0:true )}}</span>
        </td>
        <td colspan="3" class="widget-text-total">&nbsp;</td>

        <td colspan="21" class="widget-text-total">&nbsp;</td>
      </tr>
    </tbody>

  </table>

  <table data-id="widgetHRentRoll" class="widget-hpage-large widget-HRentRoll CommentDesign widget-HRentRollScenario widget-HRentRollScenario-fixed-bottom" aria-hidden="true">
    <thead>
      <ng-container *ngTemplateOutlet="widgetRuller"></ng-container>
    </thead>
    <tbody>
      <tr class="infoMessage">
        <td [style.padding-top]="widgetData.footNotePaddingTop" style="background-color: white !important" colspan="56">{{'hRentRoll.labelInfoMessage' | rdTranslate}}</td>
      </tr>
    </tbody>
  </table>

</div>
